import { http } from '@/network/http';
import { useQuery } from '@tanstack/react-query';

export function useAnalyticsOverview(days = 7) {
  return useQuery({
    queryKey: ['analytics', 'overview', days],
    queryFn: () => http.get(`/analytics/overview`, { params: { days } }).then((r) => r.data),
  });
}

export function useAnalyticsPerformance(days = 7, metric = 'VIEWS') {
  return useQuery({
    queryKey: ['analytics', 'performance', days, metric],
    queryFn: () => http.get(`/analytics/performance`, { params: { days, metric } }).then((r) => r.data),
  });
}

export function useAnalyticsAudience() {
  return useQuery({
    queryKey: ['analytics', 'audience'],
    queryFn: () => http.get(`/analytics/audience`).then((r) => r.data),
  });
}

export function useVideoAnalytics(videoId: string) {
  return useQuery({
    queryKey: ['analytics', 'video', videoId],
    queryFn: () => http.get(`/analytics/videos/${videoId}`).then((r) => r.data),
    enabled: !!videoId,
  });
}
